var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportsGenerate = function SvgReportsGenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 4.9,
    y1: 160.46,
    x2: 122.6,
    y2: 27.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.71,
    y1: 165.62,
    x2: 128.41,
    y2: 33.11,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 17.78,
    y1: 171.9,
    x2: 135.48,
    y2: 39.39,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 33.94,
    y1: 186.26,
    x2: 151.64,
    y2: 53.75,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 84.49,
    y1: 231.16,
    x2: 202.2,
    y2: 98.65,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 84.49,
    y1: 231.16,
    x2: 202.2,
    y2: 98.65,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100,186.05H25.58c-3.09,0-6.04-1.23-8.22-3.4-2.18-2.19-3.4-5.13-3.4-8.22V25.58c0-3.09,1.23-6.04,3.4-8.22,2.19-2.18,5.13-3.4,8.22-3.4h76.74v30.23c0,9,7.28,16.28,16.28,16.28h30.23v30.23c0,3.85,3.13,6.98,6.98,6.98s6.98-3.13,6.98-6.98v-33.36c0-4.32-1.71-8.46-4.77-11.51L116.96,4.77C113.91,1.71,109.77,0,105.45,0H25.58C18.8,0,12.29,2.7,7.49,7.49,2.7,12.29,0,18.8,0,25.58v148.84C0,181.2,2.7,187.71,7.49,192.51c4.8,4.79,11.31,7.49,18.09,7.49h74.42c3.85,0,6.98-3.13,6.98-6.98s-3.13-6.98-6.98-6.98ZM138.98,46.51h-20.37c-1.28,0-2.33-1.04-2.33-2.33v-20.37l22.7,22.7Z",
    style: {
      fill: "url(#b)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58,86.05c0-3.85-3.13-6.98-6.98-6.98H44.19c-3.85,0-6.98,3.13-6.98,6.98s3.13,6.98,6.98,6.98h74.42c3.85,0,6.98-3.13,6.98-6.98Z",
    style: {
      fill: "url(#c)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,111.63h-41.86c-3.85,0-6.98,3.13-6.98,6.98s3.13,6.98,6.98,6.98h41.86c3.85,0,6.98-3.13,6.98-6.98s-3.13-6.98-6.98-6.98Z",
    style: {
      fill: "url(#d)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,144.19h-41.86c-3.85,0-6.98,3.13-6.98,6.98s3.13,6.98,6.98,6.98h41.86c3.85,0,6.98-3.13,6.98-6.98s-3.13-6.98-6.98-6.98Z",
    style: {
      fill: "url(#e)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.52,
    cy: 152.33,
    r: 13.95,
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.33,154.43c.07-1.4.07-2.81,0-4.21,0,0,5.23-6.83,5.23-6.83,1.42-1.85,1.82-4.3,1.07-6.5-2.01-5.84-5.13-11.25-9.18-15.9-1.53-1.76-3.85-2.63-6.16-2.33l-8.54,1.12c-1.18-.76-2.4-1.47-3.66-2.1,0,0-3.29-7.95-3.29-7.95-.89-2.16-2.81-3.72-5.1-4.17-6.07-1.19-12.3-1.19-18.36,0-2.29.45-4.2,2.01-5.1,4.17l-3.3,7.95c-1.26.63-2.47,1.34-3.66,2.11,0,0-8.53-1.13-8.53-1.13-2.32-.3-4.62.58-6.16,2.33-4.07,4.65-7.18,10.06-9.18,15.9-.75,2.2-.35,4.65,1.06,6.5l5.24,6.84c-.07,1.4-.07,2.81,0,4.21,0,0-5.24,6.83-5.24,6.83-1.41,1.85-1.81,4.3-1.06,6.5,2,5.84,5.12,11.25,9.18,15.9,1.53,1.76,3.84,2.63,6.16,2.33l8.54-1.12c1.17.76,2.4,1.47,3.66,2.1,0,0,3.29,7.95,3.29,7.95.89,2.16,2.81,3.72,5.1,4.17,6.07,1.19,12.3,1.19,18.36,0,2.29-.45,4.2-2.01,5.1-4.17l3.3-7.95c1.25-.63,2.47-1.34,3.66-2.11,0,0,8.53,1.13,8.53,1.13,2.31.3,4.62-.58,6.16-2.33,4.06-4.65,7.17-10.06,9.18-15.9.75-2.2.35-4.65-1.07-6.5l-5.23-6.84ZM179.22,149.06c.28,2.17.28,4.36,0,6.53-.24,1.83.25,3.69,1.38,5.16l4.47,5.84c-.82,1.77-1.8,3.45-2.91,5.05l-7.3-.96c-1.83-.23-3.69.26-5.15,1.39-1.74,1.34-3.65,2.44-5.67,3.27-1.71.71-3.07,2.07-3.78,3.77l-2.83,6.8c-1.93.18-3.89.18-5.82,0l-2.83-6.8c-.71-1.7-2.07-3.06-3.78-3.77-2.03-.84-3.93-1.93-5.67-3.27-1.46-1.13-3.32-1.62-5.15-1.39l-7.3.96c-1.12-1.59-2.09-3.28-2.91-5.04,0,0,4.47-5.85,4.47-5.85,1.13-1.47,1.62-3.33,1.38-5.16-.29-2.17-.29-4.36,0-6.53.24-1.83-.25-3.69-1.38-5.16l-4.47-5.84c.82-1.77,1.8-3.45,2.91-5.05l7.3.96c1.83.23,3.69-.26,5.15-1.39,1.74-1.34,3.64-2.44,5.67-3.27,1.71-.71,3.07-2.07,3.78-3.77l2.83-6.8c1.93-.18,3.89-.17,5.82,0l2.83,6.8c.71,1.7,2.07,3.06,3.78,3.77,2.02.84,3.93,1.93,5.67,3.27,1.46,1.13,3.32,1.62,5.15,1.39l7.3-.96c1.12,1.59,2.08,3.28,2.91,5.04,0,0-4.47,5.85-4.47,5.85-1.13,1.47-1.62,3.33-1.38,5.16Z",
    style: {
      fill: "url(#g)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
};
export default SvgReportsGenerate;